
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Pourquoi et comment faire du SEO local sur Google ?",
    description:
      "Le SEO local est idéal pour les commerces et artisans souhaitant attirer des clients proches. Découvrez les étapes pour optimiser votre visibilité locale sur Google.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
